import { lossIsFinal, stageOf } from '@bratva/rules';
import type { Action, SaveDoc } from '@bratva/state';

/**
 * Что делает с прохождением здоровье в ноль и наступивший день суда.
 * Логика вынесена из store, чтобы её можно было проверить тестами,
 * а не только вручную в браузере.
 */

/** Доля денег, которую забирает больничка. */
const HOSPITAL_SHARE = 0.15;
/** Доля денег, которую забирает адвокат в мягком режиме. */
const LAWYER_SHARE = 0.4;

/** Здоровье в ноль: по-мамкиному больничка, по-пацански могила. */
export function healthAction(save: SaveDoc): Action | null {
  if (save.player.health > 0 || save.outcome !== 'active') return null;

  if (lossIsFinal(save.mode)) {
    return {
      type: 'finishRun',
      outcome: 'mogila',
      text: 'Забили насмерть у гаражей. Двор помнит, но дальше без тебя.',
    };
  }
  return { type: 'hospital', lostCash: Math.round(save.player.cash * HOSPITAL_SHARE) };
}

/**
 * День суда наступил. Откупиться надо было раньше — делом у смотрящего.
 * По-пацански это конец, по-мамкиному — адвокат забирает почти всё.
 */
export function courtActions(save: SaveDoc): Action[] {
  if (save.outcome !== 'active') return [];
  if (stageOf(save.justice, save.day) !== 'sud') return [];

  if (lossIsFinal(save.mode)) {
    return [
      {
        type: 'finishRun',
        outcome: 'srok',
        text: 'Суд. Пять лет строгого режима. Дело закрыто, и прохождение вместе с ним.',
      },
    ];
  }

  return [
    { type: 'settleCourt', price: Math.round(save.player.cash * LAWYER_SHARE), how: 'Адвокат и связи' },
    { type: 'log', text: 'Отскочил: адвокат забрал почти всё, но ты дома.' },
  ];
}
